import {
    ColumnDefinition,
    ColumnDefinitionsDictionary,
    getColDefsForColumnDefinitionsDictionary,
    ValueType,
} from '@instinet-analytics/semantic-ui-components';
import { IndigoAppContextType } from 'app/AppContext.tsx';
import { ColDef } from 'ag-grid-community';
import React from 'react';
import { BucketedDataItem } from 'utils/timeseries/bucket.ts';

export type VolumeCurveGridColumn =
    | 'startTime'
    | 'endTime'
    | 'tradedVolume'
    | 'historicalVolume'
    | 'auctionVolume'
    | 'cumulativeTradedVolume'
    | 'cumulativeHistoricalVolume';

export const volumeCurveGridColumnsDefinitionDictionary: ColumnDefinitionsDictionary<VolumeCurveGridColumn> =
    {
        startTime: {
            field: 'startTime',
            name: 'Start Time',
            valueType: ValueType.TIME,
            headerTooltip: 'Bucket Start Time',
            width: 70,
        },
        endTime: {
            field: 'endTime',
            name: 'End Time',
            valueType: ValueType.TIME,
            headerTooltip: 'Bucket End Time',
            width: 70,
        },
        historicalVolume: {
            field: 'historicalVolume',
            name: 'Historical Volume',
            valueType: ValueType.NUMBER,
            precision: 0,
            headerTooltip: 'Historical Volume',
            width: 110,
        },
        cumulativeHistoricalVolume: {
            field: 'cumulativeHistoricalVolume',
            name: 'Cumulative Historical Volume',
            valueType: ValueType.NUMBER,
            precision: 0,
            headerTooltip: 'Cumulative Historical Volume',
            width: 110,
        },
        tradedVolume: {
            field: 'tradedVolume',
            name: 'Traded Volume',
            valueType: ValueType.NUMBER,
            precision: 0,
            headerTooltip: 'Traded Volume',
            width: 110,
        },
        cumulativeTradedVolume: {
            field: 'cumulativeTradedVolume',
            name: 'Cumulative Traded Volume',
            valueType: ValueType.NUMBER,
            precision: 0,
            headerTooltip: 'Cumulative Traded Volume',
            width: 110,
        },
        auctionVolume: {
            field: 'auctionVolume',
            name: 'Auction Volume',
            valueType: ValueType.NUMBER,
            precision: 0,
            headerTooltip: 'Auction Volume',
            width: 110,
        },
    };

export const volumeCurveColumnsDefinitions: ColumnDefinition[] = Object.values(
    volumeCurveGridColumnsDefinitionDictionary
);

export function getVolumeCurveColDefs(context: IndigoAppContextType) {
    const colDefs = getColDefsForColumnDefinitionsDictionary(
        context,
        volumeCurveGridColumnsDefinitionDictionary
    );

    enrichTimeColumn(context, colDefs, 'startTime');
    enrichTimeColumn(context, colDefs, 'endTime');

    return colDefs;
}

const getTimeDisplayValue = (
    context: IndigoAppContextType,
    field: keyof BucketedDataItem,
    data?: BucketedDataItem
) => {
    if (!data) {
        return '';
    }
    const value = data[field];

    if (value) {
        return context.timeFormat.toTimeMinutes(value);
    }

    return value ?? '';
};

const timeCellRenderer =
    (context: IndigoAppContextType, field: keyof BucketedDataItem) =>
    // eslint-disable-next-line react/display-name
    (props: { data: BucketedDataItem }) => {
        return <span>{getTimeDisplayValue(context, field, props.data)}</span>;
    };

function enrichTimeColumn(
    context: IndigoAppContextType,
    cols: ColDef[],
    field: keyof BucketedDataItem
) {
    const colDef = cols.find((f) => f.field === field);
    if (!colDef) {
        return;
    }

    colDef.cellRenderer = timeCellRenderer(context, field);
    // colDef.getExportValue = (_value, data) =>
    //     getExpectedRptTimeDisplayValue(context, data);
    // colDef.showDetailValue = (data: SymbolEvent | undefined) =>
    //     !isNil(data?.expectedRptTime) || !isNil(data?.expectedRptTimestamp);
}
